import React from "react";
import LessonsCard from "./components";

const Lessons = () => {
  return (
    <div>
      <LessonsCard titleName={"Math"} />
      <LessonsCard titleName={"English"} />
      <LessonsCard titleName={"Geography"} />
      <LessonsCard titleName={"Biology"} />
      <LessonsCard titleName={"Math"} />
      <LessonsCard titleName={"English"} />
    </div>
  );
};

export default Lessons;
